export default __webpack_public_path__ + "static/media/finance-vector.e7d02108.png";